import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadershipMember } from '../leaderboard-home';

@Component({
  selector: 'app-leaderboard-provider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './leaderboard-provider.html',
  styleUrl: './leaderboard-provider.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaderboardProvider {
  @Input({ required: true }) leadershipMembers: LeadershipMember[] = [];
  @Input({ required: true }) providersPagination: {
    hasNext?: boolean;
    isLoading?: boolean;
  } = {};
  @Input({ required: true }) showLoadMore = false;
  @Output() loadMore = new EventEmitter<void>();

  emitLoadMore(): void {
    this.loadMore.emit();
  }

  featuredSubtitle(member: LeadershipMember): string {
    const org = member.organizationName?.trim();
    if (org) return `Published by ${org}`;
    return member.role?.trim() || member.title?.trim() || '';
  }
}
